import BulmaTagsInput from '@creativebulma/bulma-tagsinput';

export default (selector = 'input[data-type="tags"], input[type="tags"], select[data-type="tags"], select[type="tags"]') => BulmaTagsInput.attach(selector);
